import { z } from "zod";

export const issueRefundPayloadSchema = z.object({
  customer_id: z.string().min(1),
  amount: z.number().positive(),
  currency: z.enum(["USD", "EUR", "GBP", "ILS"]),
  reason: z.string().min(1),
  original_charge_id: z.string().min(1).optional()
});

export type IssueRefundPayload = z.infer<typeof issueRefundPayloadSchema>;
